import React, { memo } from 'react';
import { StyleSheet, Text as RNText, TouchableOpacity, View, } from 'react-native';
import { rem } from 'design-system';
import { IconLock } from 'design-system/icons';
import IconLockUnlocked from 'design-system/icons/IconLockUnlocked';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import Squircle from 'design-system/Squircle';
import DottedSquircle from 'design-system/DottedSquircle';
const QuestItem = ({ item, border, onQuestPressed }) => {
    const pressed = () => {
        if (border)
            return;
        onQuestPressed(item);
    };
    const colors = useColors();
    const renderCircle = () => {
        const { status, icon } = item;
        if (status === 'VIEWED' || (status === 'UNLOCKED' && border)) {
            return (<Squircle color={colors.background.dark}>
          <RNText style={styles.emoji}>{icon}</RNText>
        </Squircle>);
        }
        return (<View>
        {status === 'LOCKED' ? (<DottedSquircle width={rem(44)} height={rem(44)}>
            <IconLock alt color={colors.text.secondary}/>
          </DottedSquircle>) : (<Squircle color={colors.background.dark}>
            <IconLockUnlocked width={24} height={24} color={colors.elements.brand}/>
          </Squircle>)}
      </View>);
    };
    if (!item)
        return null;
    const { label } = item;
    return (<TouchableOpacity style={styles.container} onPress={pressed}>
      {renderCircle()}
      {item.status === 'LOCKED' ? (<Text Text-14 Gray centered style={styles.label}>
          {label}
        </Text>) : (<Text Text-14 OffBlack centered style={styles.label}>
          {label}
        </Text>)}
    </TouchableOpacity>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        paddingVertical: rem(8),
        justifyContent: 'center',
    },
    label: {
        marginTop: rem(16),
        marginLeft: rem(10),
        marginRight: rem(10),
        flexWrap: 'nowrap',
    },
    emoji: {
        fontFamily: 'System',
        fontSize: rem(24),
        textAlignVertical: 'center',
    },
});
export default memo(QuestItem);
